import React from 'react'
import { SvgIconProps } from './Home'

const SvgCoachesIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="16"
    fill="none"
    viewBox="0 0 19 16"
  >
    <path
      fill={fill ?? "#353535"}
      d="M17.374 6.27a5.06 5.06 0 00-3.759-1.621h-4.47c-.407 0-.813.432-.813.865v.432H7.01v-.432c0-.433-.407-.865-.813-.865H.813c-.407 0-.813.432-.813.865v3.35c0 .433.305.758.711.866l7.519.973C8.433 13.622 10.77 16 13.615 16 16.561 16 19 13.405 19 10.27a6.955 6.955 0 00-1.626-4zm-3.86 8c-2.033 0-3.658-1.73-3.658-3.892s1.625-3.891 3.657-3.891c2.033 0 3.76 1.73 3.76 3.891 0 2.163-1.727 3.892-3.76 3.892zM6.197 7.676H8.84c-.204.432-.407.865-.508 1.297l-6.706-.865v-1.73h3.657v.433c0 .54.407.865.915.865z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M13.513 7.351c-1.524 0-2.845 1.298-2.845 3.027 0 1.622 1.321 3.027 2.845 3.027 1.524 0 2.845-1.297 2.845-3.027 0-1.73-1.219-3.027-2.845-3.027zm0 4.217c-.61 0-1.219-.541-1.219-1.298 0-.648.508-1.297 1.22-1.297.609 0 1.219.54 1.219 1.297 0 .757-.508 1.298-1.22 1.298zM6.096 4.108c.102.216.407.324.61.324a.752.752 0 00.508-.216c.102-.108.203-.216.203-.324.102.324.407.54.711.54.305 0 .61-.216.712-.54.101.216.203.324.304.324a.753.753 0 00.508.216c.305 0 .508-.108.61-.324l1.422-1.946c.102-.216.204-.432.204-.648a.601.601 0 00-.305-.541c-.203-.108-.406-.216-.61-.216a.555.555 0 00-.508.324L9.043 3.027V.865C9.043.432 8.636 0 8.23 0c-.406 0-.813.432-.813.865v2.162L5.995 1.081C5.69.757 5.182.65 4.877.973c-.406.216-.508.865-.203 1.19l1.422 1.945z"
    ></path>
  </svg>
)


export default SvgCoachesIcon